<!-- Special Component  -->
<template>
  <GfrDropdown>
    <GfrDropdownTrigger class="app-language-trigger">
      <IconsGlobe class="h-4 w-4" />
    </GfrDropdownTrigger>
    <GfrDropdownContent
      :offset-y="0"
      :offset-x="0"
      wrapper-class="z-50 lg:!top-5 !top-2"
      :placement="isMobile ? 'bottom-center' : isAr ? 'bottom-start' : 'bottom-end'"
      class="max-h-77 max-lg:landscape:max-h-[48vh] w-auto min-w-35 max-w-max overflow-hidden text-light bg-dark lg:max-h-[13.125rem] lg:min-w-28"
    >
      <GfrScrollArea v-model:reset="resetScroll" class="h-full">
        <GfrDropdownItem v-for="item in list" :key="item.id" class="app-language-item">
          <a
            class="app-language-link"
            :class="isActive(item.name) && 'app-language-link-active !font-bold'"
            :href="formatPath(item.name, item.region || '')"
          >
            {{ item.label }}
          </a>
        </GfrDropdownItem>
      </GfrScrollArea>
    </GfrDropdownContent>
  </GfrDropdown>
</template>

<script setup lang="ts">
export interface LanguageItem {
  id: number
  name: string
  label: string
  region?: string
  default?: boolean
}
const props = defineProps({
  onlySelf: Boolean, // 保持当前链接，仅切换语言
  global: {
    // 是否适用全区语言列表，为否要添加region属性
    type: Boolean,
    default: true
  },
  list: {
    type: Array as PropType<LanguageItem[]>,
    default: () => []
  },
  offsetY: {
    type: Number,
    default: 0
  },
  offsetX: {
    type: Number,
    default: 0
  }
})
const resetScroll = ref(false)
const route = useRoute()
const { isAr } = useLang()
const { isMobile } = useDevice()
function isActive(routeName: string): boolean {
  return route.path.startsWith(`/${routeName}`)
}
function formatPath(name: string, region: string): string {
  const path = props.global ? `/${name}` : `/${region}_${name}`
  return props.onlySelf ? route.path.replace(`/${route.params.lang}`, path) : `${path}/`
}
</script>

<style lang="scss" scoped>
.app-language-trigger {
  @apply rounded-full bg-dark-background p-1 lg:p-2 text-light transition-colors duration-300 data-[state=open]:text-primary;
  @apply lg:hover:text-primary-hover lg:hover:data-[state=open]:text-primary;
}

.app-language-item {
  @apply transition-colors duration-300 lg:hover:text-primary text-sm;
}

.app-language-link {
  @apply inline-flex h-11 w-full items-center justify-center px-2 font-medium lg:h-7.5 lg:font-normal;
  &-active {
    @apply bg-dark-background text-primary;
  }
}
</style>
